import { render, staticRenderFns } from "./EditAttachItem.vue?vue&type=template&id=97772298&"
import script from "./EditAttachItem.vue?vue&type=script&lang=js&"
export * from "./EditAttachItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports